var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColdWalletRoundSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 21.3333,
    fill: "#DD6700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 32H44V40H40V32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22V18C48 15.794 46.206 14 44 14H18C14.692 14 12 16.692 12 20V44C12 48.402 15.588 50 18 50H48C50.206 50 52 48.206 52 46V26C52 23.794 50.206 22 48 22ZM18 18H44V22H18C17.485 21.977 16.9988 21.7562 16.6426 21.3836C16.2863 21.0111 16.0875 20.5155 16.0875 20C16.0875 19.4845 16.2863 18.9889 16.6426 18.6164C16.9988 18.2438 17.485 18.023 18 18ZM48 46H18.024C17.1 45.976 16 45.61 16 44V25.63C16.628 25.856 17.294 26 18 26H48V46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdWalletRoundSquareIcon);
export default __webpack_public_path__ + "static/media/Cold Wallet Round Square Icon.31b3fbfdcb6fcc1a23a381f2f9e99892.svg";
export { ForwardRef as ReactComponent };